import _ from 'underscore';

import { METRIC_OPTIONS } from '@bingads-webui-campaign-react/top-locations-card-const';


export const getPropsFromPreferenceForTopLocations = ({
  cardPreference,
  patchPreference,
  campaignType,
}) => {
  let preferenceFromServer = _.get(cardPreference, 'metric');
  if (!_.isString(preferenceFromServer)
    || !METRIC_OPTIONS.includes(preferenceFromServer)
  ) {
    preferenceFromServer = _.first(METRIC_OPTIONS);
  }

  return {
    preferenceFromServer,
    patchPreference,
    campaignType,
  };
};
